import { Thumbmark } from '@thumbmarkjs/thumbmarkjs';

const thumbmark = new Thumbmark({
  logging: false,
  timeout: 1000
});

let deviceIdPromise: Promise<string> | undefined;

export const getThumbmarkDeviceId = (): Promise<string> => {
  deviceIdPromise ??= thumbmark.get().then(({ thumbmark: deviceId }) => deviceId);
  return deviceIdPromise;
};
